export enum UserRoles {
  ADMIN = 'administrator',
  LEARNING_DESIGNER = 'learning-designer',
  LEARNER = 'ck/learner',
  FACILITATOR = 'facilitator',
}
